<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  computed: {
    ...mapGetters('auth', ['user']),
  },

  created() {
    if (this.user) {
      this.$root.syncUserpilot(this.user)
    }
  },
}
</script>

<template>
  <child />
</template>
